
/** timeAgo */

export const timeAgo = (date_str) => {

      const current = new Date()
      const time_at = new Date(date_str)

      const diff = current - time_at 
      const seconds = Math.floor(diff / 1000)
      const minutes = Math.floor(seconds / 60)
      const hours = Math.floor(minutes / 60)
      const days = Math.floor(hours / 24)

      if(days > 0){
            return `${days} ${days === 1 ? 'day' : 'days'} Ago`
      } else if(hours > 0){
            return `${hours} ${hours === 1 ? 'hour' : 'hours'} Ago`
      } else if(minutes > 0){
            return `${minutes} ${minutes === 1 ? 'minutes' : 'minutes'} Ago`
      }else{
            return `${seconds} ${seconds === 1 ? 'second' : 'seconds'} Ago`
      }
}

/** post_At */

export function post_at(date_str){

      const months = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun", 
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ]

      const week = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]

      const date = new Date(date_str)
      const month = months[date.getMonth()]
      const day = date.getDate()
      const year = date.getFullYear()
      const current = new Date()
      const week_day = week[date.getDay()]

      if(date.toDateString() === current.toDateString()){
            return `${month}, ${day} ${week_day} - ${year}`
      } else{
            return `${month}, ${day} ${week_day} - ${year}`
      }
}

/** break line */

export function break_line(text){
      text = text.replace(/&#13;&#10;/g, '\r\n')
      return text
}